import { render, staticRenderFns } from "./DishPicture.vue?vue&type=template&id=269cd062&lang=pug"
import script from "./DishPicture.vue?vue&type=script&lang=js"
export * from "./DishPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports